import { NotFound } from './components/NotFound';
import { datadogRum } from '@datadog/browser-rum';
import { useUserTracking } from '@project44/ui-utils';

export default function App() {
  useUserTracking(datadogRum, '@project44/not-found-ui');

  return <NotFound />;
}
